import { createSlice } from '@reduxjs/toolkit';
import {
  signinUser,
  getAddressesByZipCodeSignup,
  logoutUser,
  fetchSavedDeliverySettings,
  getAuthenticatedUser,
  fetchAllowedPaymentType,
  fetchUserScreenVisibilitySettings,
  createUserScreenVisibilitySettings,
} from '~/api';
import { GMOASK_STATUS } from '~/constants/api';

const initialState = {
  id: '',
  name: '', // ここの初期値の空文字を元に申込みページでユーザー登録直後かどうか判定をしている
  category: '',
  individualCategory: '',
  companyName: '',
  departmentName: '',
  email: '',
  password: '',
  confirmPassword: '',
  phone: '',
  zip: '',
  pref: '',
  address: '',
  antisocialCheckStatus: null,
  antisocialCheckApprovalStatus: null,
  creditCheckStatus: null,
  allowInvoice: false,
  screenVisibilitySettings: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    initialize: () => initialState,

    // 401エラーが発生したら初期化
    unauthorizedErrorRaised: () => initialState,

    change: (state, action) => {
      return {
        ...state,
        ...action.payload.user,
      };
    },
  },
  // 非同期はextraReducersで行う
  extraReducers: {
    [fetchSavedDeliverySettings.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload.users,
        id: action.payload.userId,
      };
    },
    [signinUser.fulfilled.type]: (state, action) => {
      if (action.payload.status === GMOASK_STATUS.OK) {
        return {
          ...state,
          id: action.payload.result.id,
        };
      }
      return { ...state };
    },

    [getAddressesByZipCodeSignup.fulfilled.type]: (state, action) => {
      if (action.payload.length > 0) {
        return {
          ...state,
          pref: action.payload[0].prefChar,
          address: action.payload[0].cityChar + action.payload[0].townChar,
        };
      }
      return state;
    },

    [logoutUser.fulfilled.type]: () => {
      return initialState;
    },

    [getAuthenticatedUser.fulfilled.type]: (state, action) => {
      return {
        ...state,
        ...action.payload.result,
      };
    },

    [fetchAllowedPaymentType.fulfilled.type]: (state, action) => {
      return {
        ...state,
        allowInvoice: action.payload.result.allowInvoice,
      };
    },

    [fetchUserScreenVisibilitySettings.fulfilled.type]: (state, action) => {
      return {
        ...state,
        screenVisibilitySettings: action.payload.result,
      };
    },

    [createUserScreenVisibilitySettings.fulfilled.type]: (state, action) => {
      return {
        ...state,
        screenVisibilitySettings: [
          ...state.screenVisibilitySettings,
          action.payload.result.screenVisibilitySettingId,
        ],
      };
    },
  },
});

export const { unauthorizedErrorRaised } = userSlice.actions;

// reducerをexportする
export default userSlice.reducer;
